const WISHLIST_KEY = "innovate.wishlist"
checkLocalStorage()
checkBtns()

document.addEventListener('DOMContentLoaded', ()=>{

    if (location.pathname.includes('/pages/favoritos')) {
        const productContainer = document.querySelector('.grid--collection')
        const wishlistLS = JSON.parse(localStorage.getItem(WISHLIST_KEY))

        wishlistLS.forEach(wishlistItem => renderVariants(wishlistItem, productContainer));

        document.addEventListener('click', (evt)=>{

            if (evt.target.matches('.wishlist--btn') || evt.target.closest('.wishlist--btn')) {
                evt.preventDefault()
                const itemFilled = evt.target.closest('.wishlist--btn')
                removeItemHandler(itemFilled)

                location.reload()
            }

        })
    }

    const [...wishlistBtnEmpty] = document.querySelectorAll('.wishlist--btn[data-state="empty"]')
    const [...wishlistBtnFilled] = document.querySelectorAll('.wishlist--btn[data-state="filled"]')

    wishlistBtnEmpty.forEach( itemEmpty => {

        itemEmpty.addEventListener('click',(evt)=>{
            evt.preventDefault()
            const dataHandle = itemEmpty.dataset.handle
            const [handle, variantId] = dataHandle.split('_')
            const dataLS = JSON.parse(localStorage.getItem(WISHLIST_KEY))

            const existHandle = dataLS.find(element => element.handle === handle)
            if (existHandle) {
              existHandle.variants.push(Number(variantId))
            }else{
              dataLS.push({
                handle,
                variants: [Number(variantId)]
              })
            }


            localStorage.setItem(WISHLIST_KEY, JSON.stringify(dataLS))

            const relatedbtn = itemEmpty.parentElement.querySelector('.wishlist--btn[data-state="filled"]')
            relatedbtn.style.display = "flex"
            itemEmpty.style.display = "none"

        })
    });

    wishlistBtnFilled.forEach( itemFilled => {
        itemFilled.addEventListener('click',(evt)=>{
            evt.preventDefault()
            removeItemHandler(itemFilled)

            const relatedbtn = itemFilled.parentElement.querySelector('.wishlist--btn[data-state="empty"]')
            relatedbtn.style.display = "flex"
            itemFilled.style.display = "none"

        })
    });

})

function removeItemHandler(itemFilled) {
  const dataHandle = itemFilled.dataset.handle
  const [handle, variantId] = dataHandle.split('_')
  let dataLS = JSON.parse(localStorage.getItem(WISHLIST_KEY))

  const existHandle = dataLS.find(element => element.handle === handle)
  if (existHandle) {
    if (existHandle.variants.length == 1) {
      dataLS.splice(dataLS.indexOf(existHandle),1)
    }else{
      existHandle.variants.splice(existHandle.variants.indexOf(Number(variantId)),1)
    }
  }


  localStorage.setItem(WISHLIST_KEY, JSON.stringify(dataLS))
}


async function renderVariants(wishlistItem, productContainer) {
    const request = await fetch(`/products/${wishlistItem.handle}.js`)
    const product = await request.json()
    const productVariant = []
    wishlistItem.variants.forEach(variantId =>{
        const prodVariant = product.variants.find(variant => variant.id === variantId)

        if (prodVariant) {
            productVariant.push(prodVariant)
        }
    })

    productVariant.forEach(variant => {
        productContainer.insertAdjacentHTML('afterbegin',`
        <div class="grid__item grid__item-padding-left grid-product small--one-half medium-up--one-third aos-init aos-animate" data-aos="row-of-" data-product-handle="lz-1-screen-reading ">
        <div class="grid-product__content">
        <div class="wishlist">
            <a href="#" class="wishlist--btn" data-state="empty" data-handle="${wishlistItem.handle}_${variant.id}" style="display: flex;" tabindex="0">
                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
                <g id="icon_fav" transform="translate(-1606.921 -59.921)">
                <rect id="Rectángulo_685" data-name="Rectángulo 685" width="26" height="26" transform="translate(1606.921 59.921)" fill="none"></rect>
                <path id="Unión_2" data-name="Unión 2" d="M18850.467-1427.427a5.607,5.607,0,0,1-1.549-3.836,5.669,5.669,0,0,1,1.648-4.044,5.668,5.668,0,0,1,4.02-1.7h.016a5.808,5.808,0,0,1,3.977,1.591l.02.024a7.161,7.161,0,0,1,.535.653,7.41,7.41,0,0,1,.5-.649l.023-.024a5.722,5.722,0,0,1,4.045-1.667,5.669,5.669,0,0,1,4.059,1.686,5.746,5.746,0,0,1,1.293,6.038v0a5.419,5.419,0,0,1-1.127,1.762l-8.639,9.088Zm1.662-6.318a3.474,3.474,0,0,0-.98,2.463v.009a3.261,3.261,0,0,0,.934,2.33l7.174,7.274,7.1-7.407a3.83,3.83,0,0,0,.645-1.08,3.442,3.442,0,0,0-.076-2.652,3.44,3.44,0,0,0-1.928-1.833,3.466,3.466,0,0,0-1.236-.227,3.5,3.5,0,0,0-3.254,2.23,3.462,3.462,0,0,0-.227,1.274l0,.862h-2.248l.014-.871a3.227,3.227,0,0,0-.928-2.311l-.076-.076a.128.128,0,0,1-.029-.024l-.18-.171a3.449,3.449,0,0,0-2.244-.824A3.427,3.427,0,0,0,18852.129-1433.744Z" transform="translate(-17239.246 1500.886)" fill="#355541"></path>
                </g>
            </svg>
            </a>
            <a href="#" class="wishlist--btn" data-state="filled" data-handle="${wishlistItem.handle}_${variant.id}" style="display: none;" tabindex="0">
                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
                <g id="icon_fav-r" transform="translate(-1606.922 -59.921)">
                <rect id="Rectángulo_685" data-name="Rectángulo 685" width="26" height="26" transform="translate(1606.921 59.921)" fill="none"></rect>
                <path id="Unión_2" data-name="Unión 2" d="M18850.5-1427.43a5.614,5.614,0,0,1-1.549-3.836,5.662,5.662,0,0,1,1.648-4.044,5.669,5.669,0,0,1,4.018-1.7h.018a5.815,5.815,0,0,1,3.977,1.591l.02.024a6.917,6.917,0,0,1,.535.653,7.078,7.078,0,0,1,.5-.649l.023-.024a5.725,5.725,0,0,1,4.045-1.667,5.674,5.674,0,0,1,4.059,1.686,5.744,5.744,0,0,1,1.293,6.038h0a5.385,5.385,0,0,1-1.125,1.762l-8.641,9.088Z" transform="translate(-17239.246 1500.886)" fill="#355541"></path>
                </g>
            </svg>
            </a>
        </div>
        <a href="${product.url}?variant=${variant.id}" class="grid-product__link">
            <div class="grid-product__image-mask">
                <div class="image-wrap" style="height: 0; padding-bottom: 100.0%;">
                    <img class="grid-product__image lazyautosizes lazyloaded" data-widths="[360, 540, 720, 900, 1080]" data-aspectratio="1.0" data-sizes="auto" alt="" data-srcset=""" sizes="415px" srcset="${variant.featured_image.src}">
                    <noscript>
                <img class="grid-product__image lazyloaded"
                    src="${variant.featured_image.src}"
                    alt="">
                </noscript>
                </div>
            </div>
            <div class="grid-product__meta">
                <div class="grid-product--title-price">
                    <div class="wishlist-product__data">
                        <p>${product.title}</p>
                        <span>$${(product.price / 100).toFixed(2)}</span>
                    </div>
                </div>
            </div>
        </a>
    </div>
    </div>
    `)
    })

}

function checkLocalStorage() {
    const wishlistLS = localStorage.getItem(WISHLIST_KEY)

    if (!wishlistLS) {
        localStorage.setItem(WISHLIST_KEY, JSON.stringify([]))
    }
}

function checkBtns() {
    const wishlistLS = JSON.parse(localStorage.getItem(WISHLIST_KEY))
    if (wishlistLS.length > 0) {

        wishlistLS.forEach(wishlistItem => {
            const handle = wishlistItem.handle

            wishlistItem.variants.forEach(variantId =>{
              const wishlistBtnEmpty = document.querySelector(`.wishlist--btn[data-state="empty"][data-handle="${handle}_${variantId}"]`)
              const wishlistBtnFilled = document.querySelector(`.wishlist--btn[data-state="filled"][data-handle="${handle}_${variantId}"]`)
              if (wishlistBtnEmpty) wishlistBtnEmpty.style.display = "none"
              if (wishlistBtnFilled) wishlistBtnFilled.style.display = "flex"
            })

        });
    }
}
